import {
  account,
  batches, binData,
  blockchainUrl,
  cashFlow,
  connectedServices,
  currencies,
  defaultFee,
  document,
  exchanger,
  fee,
  logs,
  masterBalance,
  masterRefilling,
  navbar,
  nickname,
  payment,
  payout,
  project,
  rates,
  riskScore,
  service, serviceBalance,
  supportUser, swap, systemCommand,
  transfer, userAdminFields,
  users,
  verificationSchema
} from "./rbac-consts";

const rules = {
  ROLE_SUPPORT: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.PAYMENTS,
      navbar.PAYOUTS,
      account.SUPPORT,
      payment.SUPPORT,
      payout.SUPPORT
    ]
  },
  ROLE_ADMIN: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.SERVICES,
      navbar.CURRENCIES,
      navbar.FEE,
      navbar.USERS,
      navbar.RATES,
      navbar.BIN_DATA,
      account.ADMIN,
      service.ADMIN,
      service.CLIENT_LIST,
      navbar.DEFAULT_FEE,
      navbar.BASE_RATES,
      navbar.BATCHES,
      navbar.LOGS,
      navbar.TRANSFER,
      currencies.ADMIN,
      navbar.BLOCKCHAIN_URL,
      navbar.CASH_FLOW,
      fee.ADMIN,
      users.ADMIN,
      nickname.CHANGE,
      payment.ADMIN,
      payout.ADMIN,
      defaultFee.ADMIN,
      rates.ADMIN,
      batches.ADMIN,
      logs.ADMIN,
      blockchainUrl.ADMIN,
      cashFlow.ADMIN,
      transfer.ADMIN,
      binData.ADMIN,
      exchanger.ADMIN,
      serviceBalance.ADMIN
    ]
  },
  ROLE_USER: {
    static: [
      navbar.HOME,
      navbar.ACCOUNT,
      navbar.PROJECTS,
      navbar.SERVICES,
      navbar.CONNECTIONS,
      navbar.PAYMENTS,
      navbar.PAYOUTS,
      navbar.TRANSFER,
      navbar.EXCHANGE,
      navbar.DOCUMENTS,
      navbar.CRYPTOCOINS,
      navbar.RATES,
      navbar.CLIENT_FEES,
      navbar.VERIFICATION_SCHEMA,
      navbar.BATCHES,
      navbar.CASH_FLOW,
      account.USER,
      service.USER,
      connectedServices.USER,
      document.USER,
      payment.USER,
      payout.USER,
      transfer.USER,
      exchanger.USER,
      project.USER,
      riskScore.USER,
      batches.USER,
      rates.USER,
      fee.USER,
      verificationSchema.USER,
      cashFlow.USER
    ]
  },
  ROLE_SUPER_ADMIN: {
    static: [
      navbar.HOME,
      navbar.USERS,
      navbar.PAYMENTS,
      navbar.PAYOUTS,
      navbar.SUPPORT_USER,
      navbar.SYSTEM_COMMAND,
      navbar.SERVICES_BALANCES,
      payout.SUPER_ADMIN,
      payment.SUPER_ADMIN,
      service.SUPER_ADMIN,
      service.CLIENT_LIST,
      users.SUPER_ADMIN,
      supportUser.SUPER_ADMIN,
      systemCommand.SUPER_ADMIN,
      nickname.CHANGE,
      serviceBalance.SUPER_ADMIN,
      userAdminFields.CHANGE
    ]
  },
  ROLE_MASTER: {
    static: [
      navbar.HOME,
      navbar.MASTER_BALANCE,
      navbar.MASTER_REFILLING,
      navbar.SWAP,
      navbar.EXCHANGE,
      masterBalance.MASTER,
      masterRefilling.MASTER,
      exchanger.MASTER,
      swap.MASTER
    ]
  }
};

export default rules;
